import React, {useEffect, useState} from 'react'
import styles from './styles.module.css'
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getApplicant, addApplicant, getStudyYear, getEduProgram, getFaculty, getTrainingDirect, setPage} from '../../actions/encryptionKeys';
import {usePermission} from '../../hooks';
import Loader from "react-loader";
import moment from 'moment';
import Filters from './Filters';
import { Pagination } from '../../assets/Pagination/Pagination';
const Index = ({
    data, 
    getApplicant, 
    addApplicant, 
    loading,
    getStudyYear,
    getEduProgram,
    getFaculty,
    getTrainingDirect,
    studyYears,
    edu_program,
    faculty,
    trainingDirect,
    pageNumber, 
    pageCount,
    count,
    setPage
}) => {

    const [file,
        setFile] = useState(null); // blob файла
    const [filters, 
        setFilters] = useState({}); 

    const { readRight, updateRight } = usePermission('Справочники', 'Кандидаты');
    
    const pageClick = ({selected}) => {
        if (pageNumber === selected) {
            setPage(0);
        } else {
            setPage(selected);
        }
        getApplicant(filters);
    };

    useEffect(() => { // filters init
      getStudyYear();
      getEduProgram();
      getFaculty();
      getTrainingDirect();
      setPage(0);
    }, [])

    useEffect(() => {
        pageClick({selected: 0});
    }, [filters])

    const selectFileHandler = e => { // select file
        const file = e.target.files[0]
        setFile(prev => (file));
    }

    useEffect(() => {
        if (file !== null) {
            addApplicant(file, filters);
            setFile(null);
        }
    }, [file])

    if (!readRight && !updateRight) {
        return (
            <div className={styles.wrapper}>
                <p className={styles.title}>Кандидаты</p>
                <p className={styles.error}>Не достаточно прав</p>
            </div>
        )
    }

    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>Кандидаты</p>
            
            <div className={styles.panel}>
            <Filters 
                filters={filters} 
                setFilters={setFilters}
                studyYears={studyYears}
                edu_program={edu_program}
                faculty={faculty}
                trainingDirect={trainingDirect}
                />


            {updateRight &&
            <div className={styles.import}>
                <label className={styles.button} htmlFor="fileInput">Импорт из LMS Школа</label>
                {!loading && <input id="fileInput" hidden type="file" onChange={selectFileHandler}/>}
            </div>
            }
            </div>

            {loading && <div className={styles.loader}><Loader color="#7b2b2a" loaded={false}/></div>}

            <div className={styles.pagination}>
                <Pagination
                pageCount={pageCount}
                onPageChange={pageClick}
                numberPage={pageNumber}
                />
            </div>
            {!loading && 
            <div className={styles.table}>
                <table>
                    <thead>
                    <tr>
                        <th>ФИО</th>
                        <th>Дата</th>
                        <th>Факультет для поступления</th>
                        <th>Военная специальность</th>
                        <th>Направление подготовки</th>
                        <th>Статус</th>
                        <th>Дата прибытия</th>
                        <th>Зачислен</th>
                        <th>Год набора</th>
                        <th>Допуск</th>
                        <th>Рег. номер</th>
                        <th>Вх. номер</th>
                        <th>Документы отправлены</th>
                        <th>№ группы</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data && data.length
                        ? data.map((item) => (
                            <tr key={item.xp_key}>
                                <td>{item['ФИО']}</td>
                                <td>{item['Дата'] ? moment(item['Дата']).format('DD.MM.YYYY') : ''}</td>
                                <td>{item['Факультет для поступления']}</td>
                                <td>{item['Военная специальность']}</td>
                                <td>{item['Направление подготовки']}</td>
                                <td>{item['Статус']}</td>
                                <td>{item['Дата прибытия'] ? moment(item['Дата прибытия']).format('DD.MM.YYYY') : ''}</td>
                                <td>{item['Зачислен']}</td>
                                <td>{item['Год набора']}</td>
                                <td>{item['Допуск']}</td>
                                <td>{item['Рег. номер']}</td>
                                <td>{item['Вх. номер']}</td>
                                <td>{item['Документы отправлены']}</td>
                                <td>{item['№ группы']}</td>
                            </tr>
                        ))
                        : <tr>
                            <td colSpan="15">Данные отсутствуют</td>
                        </tr>
                }
                    </tbody>
                </table>
            </div>
            }
        </div>
    )
}

const mapStateToProps = (state) => ({
    data: state.encryptionKeys.applicant, 
    loading: state.encryptionKeys.applicant_loading,
    studyYears: state.encryptionKeys.studyYears,
    edu_program: state.encryptionKeys.edu_program,
    faculty: state.encryptionKeys.faculty,
    trainingDirect: state.encryptionKeys.trainingDirect,
    pageNumber: state.encryptionKeys.pageNumber,
    pageCount: state.encryptionKeys.pageCount,
});

export default withRouter(connect(
    mapStateToProps, {
        getApplicant, 
        addApplicant, 
        getStudyYear, 
        getEduProgram, 
        getFaculty, 
        getTrainingDirect, 
        setPage})(Index));